import { AppError } from './app-error';

export class EmptyResponseError extends AppError {
  public constructor() {
    super('empty-response', 'Empty response');
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = EmptyResponseError.name;
  }
}
